import { PublicProfile as PublicProfileComponent } from '@/components/PublicProfile';

export default function PublicProfile() {
  return <PublicProfileComponent />;
}